<template>
  <Content id="School">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col>
            <FormItem  label="学校名称"  prop="name" :label-width="75">
              <el-select v-model.trim="search.name" placeholder="学校名称"
                         clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width: 100%;">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleRemoteMethodChange(item)" style="width: 100%;"
                />
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="name" label="学校名称" min-width="200"/>
      <el-table-column align="center" prop="type" label="类型"  min-width="60">
        <template slot-scope="{row}">{{ converType(row.type) }}</template>
      </el-table-column>
      <el-table-column align="center" prop="gradeRange" label="年级范围"  min-width="130">
        <template slot-scope="{row}">{{ row.lowGradeName + " -- " + row.higtGradeName }}</template>
      </el-table-column>
      <el-table-column align="center" prop="otherGradeName" label="其他年级" min-width="130"/>
      <el-table-column align="center" prop="contactPerson" label="联系人" min-width="80"/>
      <el-table-column align="center" prop="telphone" label="联系电话" min-width="120"/>
      <el-table-column align="center" prop="address" label="地址" show-overflow-tooltip min-width="80"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="60" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
           show-elevator show-sizer show-total @on-change="chagecurrent"
           :page-size-opts="[10, 30, 50, 100]"
           @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <SchoolEdit ref="edit" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import { _page, _updateStatus} from "@/services/school/school";
import {_schoolsList} from "@/services/studentManage/studentManage";
import SchoolEdit from "./SchoolEdit";
import {enums} from "@/services/enums";
export default {
  name: "School",
  components: {
    SchoolEdit
  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        name: "",
        status:1
      },
      enums:enums,
      schoolList:[],
      editWindow:false,
      windowTitle:"新增",
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.getAllName();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    converType(type){
      let result = "";
      if(!type){
        return result;
      }

      if(type.toString().indexOf("1") > -1){
        result += "幼儿园,";
      }
      if(type.toString().indexOf("2") > -1){
        result += "小学,";
      }
      if(type.toString().indexOf("3") > -1){
        result += "初中,";
      }
      if(type.toString().indexOf("4") > -1){
        result += "高中,";
      }
      if(type.toString().indexOf("5") > -1){
        result += "大学,";
      }
      return result.substring(0, result.length - 1);
    },
    handleRemoteMethodChange(item) {
      this.search.id = item.id;
      this.search.name = item.name;
    },
    async getAllName(){
      _schoolsList().then(res=>{
        if (res.errcode === 1 && res.data) {
          this.schoolList = res.data;
        }
      });
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    async handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs['edit'].handleModal(row);
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
